import React, { useState, useRef, useEffect } from "react";
import { Button } from "primereact/button";
import { InputText } from 'primereact/inputtext';
import constants from "../constants/constants";
import axios from "axios";
import { useHistory } from 'react-router-dom';
import { Toast } from "primereact/toast";
import { useStoreActions } from "easy-peasy";

function Passcode({ setShowFormValue, successToast, failureToast, setPasscode, setMailId }) {
    const toast = useRef(null);
    const [value, setValue] = useState("")
    const [waitMessage, setWaitMessage] = useState(false)
    const [error, setError] = useState(false)
    const history = useHistory();
    const setUserIdLogin = useStoreActions((actions) => actions.projectModel.setUserIdLogin);

    const goto = (to) => {
        history.replace(to);
    };
const [otp, setOtp] = useState(["", "", "", "", "", ""]);

const handleOtpChange = (e, index) => {
    const val = e.target.value.replace(/\D/g, ""); // Allow only digits
    if (val.length <= 1) {
        const updatedOtp = [...otp];
        updatedOtp[index] = val;
        setOtp(updatedOtp);
        setValue(updatedOtp.join("")); // Update full value
    }
};
    const onSubmit = () => {
        const payload = {
            resetToken: value
        }

        if (value.length === 6) {
            setWaitMessage(true)
            axios.post(constants.URL.VERIFY_TOKEN, payload)
                .then((resp) => {
                        setUserIdLogin(resp?.data?.user_id);
                    if (resp) {
                        toast.current.show({ severity: "success", summary: "Success", detail: "You can change your Password now" });
                        goto("/forgot-password");
                    }

                })
                
                .catch((err) => {
                    console.log(err)
                    toast.current.show({ severity: "error", summary: "Failure", detail: "Please enter correct code" });
                })
                .finally(() => setWaitMessage(false))
        }
        else {
            setError(true)
        }
    };

    return (
        <div>
            <Toast ref={toast} />
            <div className="login_container">
                <div className="md:col-6 hidden md:flex p-3" style={{ height: "100%" }}>
                    <div class="ls-admin_bg flex justify-content-center align-items-center text-align-center">
                        <div className="flex justify-content-center align-items-center text-align-center">
                            {/* <span><img src={Logo} alt="logo" className="" /></span> */}
                        </div>
                    </div>
                </div>

                <div className="col-12 md:col-6 flex justify-content-center align-items-center text-align-center">
                    <div className="w-full justify-content-center align-items-center text-align-center flex">
                        <div className="w-full lg:w-6">
                            <div className="mb-5 pb-4">
                                {/* <img src={profile} alt="profile" className="" /> */}
                            </div>
                            <form onSubmit={onSubmit} className="error_msg">
                                <h4 className="l-heading text-center">CODE VERIFICATION</h4>
                                <div>
                                    <div className="flex align-items-center text-center justify-content-center passcode-in">
                                        <label htmlFor="token" className="login_input_label mx-2 ">
                                            Enter Code
                                        </label>
                                        <div style={{ display: "flex", gap: "0.5rem" }}>
                                            {otp.map((digit, idx) => (
                                                <InputText
                                                    key={idx}
                                                    maxLength={1}
                                                    value={digit}
                                                    onChange={(e) => handleOtpChange(e, idx)}
                                                    className="p-inputtext-sm text-center"
                                                    style={{width: '35px', borderRadius:'10px'}}
                                                />
                                            ))}
                                        </div>
                                        {error ? <p className="p-error">Please enter 6 digit code</p> : null}
                                        {waitMessage ? <span className="mx-2 please_wait_text">Please Wait...</span> : null}
                                    </div>
                                    <div className="mt-4">
                                        <Button type="submit" label="VERIFY" className="w-full login_btn" />
                                    </div>
                                    <div className="text-center mt-4">
                                        <span className="mail_receive_text">Don't receive the email? </span>
                                        <span className="mail_receive_link" onClick={() => history.push('/email-verification')}>Click to resend</span>
                                    </div>
                                    <div className="l-forget-text text-center mt-5">
                                        <span onClick={() => history.push('/')}>Back to <span className="email_login px-1">Login</span></span>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    );
}

export default Passcode;